/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.community-owner-alerts-title[_ngcontent-%COMP%]{padding:.5rem .5rem 0}.community-owner-alerts-title[_ngcontent-%COMP%]   .popup-title-text[_ngcontent-%COMP%]{margin:0}.community-owner-alerts-content[_ngcontent-%COMP%]{padding:.25rem}.community-owner-alerts-content[_ngcontent-%COMP%]   .float-add-button[_ngcontent-%COMP%]{position:fixed;right:1rem;top:3rem}.page-help-link[_ngcontent-%COMP%]{margin-top:-.1rem}"];
export { styles as styles };
